<template>
    <div class="sport-course-card">
        <div class="sport-course-card__image clickable m-b-20">
            <span v-if="course.company.accept_payments" data-toggle="tooltip" data-placement="top"
                  title="Accetta i coupon sconto">
                <img src="/images/accept-payments-badge.svg" alt="badge" class="accept-payment-badge">
            </span>
            <a :href="hrefCourse(course)">
                <img v-lazy="course.course_thumb_image" v-if="course.course_thumb_image"/>
                <img v-lazy="course.course_image" v-else/>
            </a>
            <!--<div class="sport-course-card__tags">
                <div v-for="(tag, index) in tempTags" :key="index" :class="'tag-' + tag.color">
                    <i class="fas" :class="tag.icon"></i>
                    {{tag.text}}
                </div>
            </div>-->
        </div>
        <div class="sport-course-card__body">
            <div v-if="course.company" class="sport-course-card__body__company-name">
                <a class="text-capitalize text-color-black" :href="course.company.url">{{course.company.name}}</a>
            </div>
            <div class="sport-course-card__body__name">
                <span>{{course.seo_name}}</span>
                <!--<div class="sport-course-card__body__rating" v-if="insideMap">
                    <i class="fa-star" :class="{fas: i <= 4, far: i > 4}" v-for="i in [1, 2, 3, 4, 5]" :key="i"></i>
                    <span class="ml-1">(4)</span>
                </div>-->
            </div>
            <p class="sport-course-card__body__address text-uppercase">
                {{getAddress(course)}}
            </p>

            <!--<div class="d-flex align-items-center mb-3">
                <span class="sport-course-card__body__age-range">
                    per ragazzi e adulti tra {{course.start_age}} - {{course.end_age}} anni
                </span>
                <div class="sport-course-card__body__rating" v-if="isDetail">
                    <i class="fa-star" :class="{fas: i <= 4, far: i > 4}" v-for="i in [1, 2, 3, 4, 5]" :key="i"></i>
                    <span class="ml-1">(4)</span>
                </div>
            </div>-->
            <!--<div class="sport-course-card__body__lessons" >
                <span v-for="day in days" class="sport-course-card__body__lessons__day"
                      :class="{'sport-course-card__body__lessons__day&#45;&#45;has-lesson': day.lesson}">{{day.name}}</span>
            </div>-->
            <!--<div class="d-flex aligned-items-center m-t-10">
                <div class="m-r-15">
                    <span class="sport-course-card__body__sport-tag" v-if="course.sport">{{course.sport.name}}</span>
                </div>
                <div class="sport-course-card__body__age-range">
                    <p class="m-0" >
                        <i class="fa fa-user"></i>
                        Da {{course.start_age}} a {{course.end_age}} anni
                    </p>
                </div>

            </div>-->


            <!--<p v-if="course.distance_from_my_position" class="sport-course-card__body__distance m-t-5">
                <i class="fa fa-map-marker-alt"></i>
                a {{getCourseDistance(course) }} da te
            </p>-->
        </div>
        <!--<div class="sport-course-card__actions">
            <a :href="hrefCourse(course)">
                <button class="btn btn-primary" >SCOPRI</button>
            </a>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: 'SportCoursCard',
        props: {
            course: {
                type: Object,
                required: true
            },
            isDetail: {
                type: Boolean,
                required: false
            },
            insideMap: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                days: [
                    {name: 'L', long: 'Lunedì'},
                    {name: 'M', long: 'Martedì'},
                    {name: 'M', long: 'Mercoledì'},
                    {name: 'G', long: 'Giovedì'},
                    {name: 'V', long: 'Venerdì'},
                    {name: 'S', long: 'Sabato'},
                    {name: 'D', long: 'Domenica'}
                ],
                tempTags: [
                    {icon: 'fa-map-marker-alt', text: 'A 10 minuti da te', color: 'orangogo'},
                    {icon: 'fa-tag', text: '-30% sconto', color: 'primary'}
                ]
            }
        },
        created() {
            if (!this.course.days) this.course.days = []
            for (const day of this.days) {
                const lesson = this.course.days.find(les => les.day.toLowerCase() === day.long.toLowerCase());
                if (lesson) {
                    day.lesson = true;
                }
            }
        },
        methods: {
            getAddress(course) {
                var address = '';

                if (course.municipality)
                    address = address + ' ' + course.municipality;

                if (course.province)
                    address = address + ' ' + course.province;

                if (course.route)
                    address = address + ',' + course.route;

                if (course.house_number)
                    address = address + ' ' + course.house_number

                if (course.zip)
                    address = address + ',' + course.zip;

                if (course.state)
                    address = address + ',' + course.state;

                return address
            },
            loadFilteredCourses(courses) {
                this.course = courses
            },
            getCourseDistance(course) {
                if (course.distance_from_my_position < 1)
                    return (course.distance_from_my_position * 1000) + " m";
                return Math.round(course.distance_from_my_position) + " km";
            },
            hrefCourse(course) {
                return `/corsi/${course.slug}`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sports/SportCourseCard.vue